import { z } from "zod";

import {
  DOMAINS,
  type DomainMastery,
  type RewardState
} from "../contracts";
import {
  difficultySchema,
  domainSchema,
  hasUniqueValues,
  kebabCaseIdentifierSchema,
  nonNegativeSafeIntegerSchema,
  timestampSchema
} from "./common";

export const domainMasterySchema = z.strictObject({
  domain: domainSchema,
  score: z.number().min(0).max(100),
  recommendedDifficulty: difficultySchema,
  updatedAt: timestampSchema
}) satisfies z.ZodType<DomainMastery>;

export const domainMasteryListSchema = z
  .array(domainMasterySchema)
  .max(DOMAINS.length)
  .refine(
    (mastery) => hasUniqueValues(mastery.map(({ domain }) => domain)),
    { message: "Mastery domains must be unique" }
  );

export const rewardStateSchema = z.strictObject({
  stamps: nonNegativeSafeIntegerSchema,
  unlockedDecorationIds: z
    .array(kebabCaseIdentifierSchema)
    .refine((decorationIds) => hasUniqueValues(decorationIds), {
      message: "Unlocked decoration identifiers must be unique"
    })
}) satisfies z.ZodType<RewardState>;
